import React, { Component } from "react";
import { Modal, Button, Table, Form, Input, Divider, message } from "antd";
import axios from "../../service/index";
import "./menuManagement.less";

class menuManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visible: false,
      lableListData: [],
      name: "",
      total: 0,
      searchData: {
        pageNum: 1,
        pageSize: 10,
      },
      labelName: "",
      essName: "",
      labelUrl: "",
      btnUrl: "",
      essUrl: "",
      btnShow: false,
      labelorderNum: "",
      labelperms: "",
      labelId: null,
      menuId: null,
      modelTitle: "新建菜单",
      classShow: false,
      esshow: false,
      pidName: "",
      pid: "",
      columns: [
        {
          title: "模块名称",
          dataIndex: "title",
          key: "title",
          align: "left",
        },
        {
          title: "排序",
          dataIndex: "orderNum",
          key: "orderNum",
          align: "left",
        },
        // {
        // 	title: '创建时间',
        // 	dataIndex: 'createTime',
        // 	key: 'createTime',
        // 	align: 'center'
        // },
        {
          title: "操作",
          key: "operation",
          align: "lfet",
          render: (record) => (
            <div>
              <span
                style={{ marginRight: "15px", color: "#277FFF", cursor: "pointer" }}
                onClick={() => {
                  this.setState({
                    visible: true,
                    esshow: true,
                    essName: record.title,
                    essUrl: record.url,
                    labelorderNum: record.orderNum,
                    labelperms: record.perms,
                    modelTitle: "编辑模块",
                    labelId: record.id,
                    classShow: false,
                  });
                }}>
                编辑
              </span>
              <span
                style={{ marginRight: "15px", color: "#277FFF", cursor: "pointer" }}
                onClick={() => {
                  this.setState({
                    visible: true,
                    labelName: record.title,
                    labelUrl: record.url,
                    labelorderNum: "",
                    modelTitle: "添加菜单",
                    classShow: true,
                    esshow: false,
                    pidName: record.title,
                    pid: record.id,
                  });
                }}>
                添加菜单
              </span>
              <span
                style={{ color: "#277FFF", cursor: "pointer" }}
                onClick={() => {
                  Modal.confirm({
                    title: "删除菜单",
                    okText: "确认",
                    cancelText: "取消",
                    content: (
                      <div>
                        <p>模块删除后将不可恢复，请谨慎操作！确定要删除吗？</p>
                      </div>
                    ),
                    onOk: () => {
                      this.delLable(record.id);
                    },
                  });
                }}>
                删除
              </span>
            </div>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.lableList();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  // 展开行
  expandedRowRender = (record) => {
    const columns = [
      {
        title: "菜单名称",
        dataIndex: "title",
        key: "title",
        align: "center",
        render: (record, item) => {
          if (item.type === 2) {
            return <span>{item.title}</span>;
          } else {
            return (
              <span>
                {item.title}
                <span className="rolestyle">[{item.perms}]</span>
              </span>
            );
          }
        },
      },
      {
        title: "排序",
        dataIndex: "orderNum",
        key: "orderNum",
        align: "center",
      },
      {
        title: "操作",
        align: "center",
        key: "operation",
        render: (record) => {
          if (record.type === 2) {
            return (
              <div>
                <span
                  style={{ marginRight: "15px", color: "#277FFF", cursor: "pointer" }}
                  onClick={() => {
                    this.setState({
                      visible: true,
                      labelName: record.title,
                      labelUrl: record.url,
                      labelorderNum: record.orderNum,
                      labelperms: record.perms,
                      modelTitle: "添加按钮",
                      menuId: record.id,
                      btnShow: true,
                      esshow: false,
                      classShow: false,
                      pidName: record.pidName,
                      pid: record.id,
                    });
                  }}>
                  添加按钮
                </span>
                <span
                  style={{ marginRight: "15px", color: "#277FFF", cursor: "pointer" }}
                  onClick={() => {
                    this.setState({
                      visible: true,
                      labelName: record.title,
                      labelUrl: record.url,
                      labelorderNum: record.orderNum,
                      labelperms: record.perms,
                      modelTitle: "编辑菜单",
                      btnShow: false,
                      menuId: record.id,
                      classShow: true,
                      esshow: false,
                      pidName: record.pidName,
                      // pidName: record.pidName
                    });
                  }}>
                  编辑
                </span>
                <span
                  style={{ color: "#277FFF", cursor: "pointer" }}
                  onClick={() => {
                    Modal.confirm({
                      title: "删除",
                      okText: "确认",
                      cancelText: "取消",
                      content: (
                        <div>
                          <p>删除后将不可恢复，请谨慎操作！确定要删除吗？</p>
                        </div>
                      ),
                      onOk: () => {
                        this.delmenuLable(record.id);
                      },
                    });
                  }}>
                  删除
                </span>
              </div>
            );
          } else {
            return (
              <div>
                <span
                  style={{ marginRight: "15px", color: "#277FFF", cursor: "pointer" }}
                  onClick={() => {
                    this.setState({
                      visible: true,
                      labelName: record.title,
                      btnUrl: record.url,
                      labelorderNum: record.orderNum,
                      labelperms: record.perms,
                      modelTitle: "编辑按钮",
                      menuId: record.id,
                      btnShow: true,
                      esshow: false,
                      classShow: false,
                      pidName: record.pidName,
                      // pid: record.pid
                    });
                  }}>
                  编辑
                </span>
                <span
                  style={{ color: "#277FFF", cursor: "pointer" }}
                  onClick={() => {
                    Modal.confirm({
                      title: "删除",
                      okText: "确认",
                      cancelText: "取消",
                      content: (
                        <div>
                          <p>删除后将不可恢复，请谨慎操作！确定要删除吗？</p>
                        </div>
                      ),
                      onOk: () => {
                        this.delmenuLable(record.id);
                      },
                    });
                  }}>
                  删除
                </span>
              </div>
            );
          }
        },
      },
    ];

    if (record.child) {
      return (
        <Table
          className="childTable"
          rowKey={(record) => record.id}
          columns={columns}
          rowClassName={(record, index) => (index % 2 !== 0 ? "table-line" : "")}
          dataSource={record.child}
          pagination={false}
          // expandedRowRender={record => this.expandedRowRender(record)} onExpand={(expanded,record)=>this.onExpandbtn(expanded,record)}
          // expandedRowRender={record => this.expandedRowRenderBTn(record)} onExpand={(expanded,record)=>this.onExpandBtn(expanded,record)}
        />
      );
    }
  };
  // 展开按钮
  onExpandbtn = (expanded, record) => {
    this.setState({
      pid: record.id,
      pidName: record.title,
    });
  };
  // 格式化数据
  formatData = (arr) => {
    return arr.map((item) => {
      item.child = item.children || [];
      return item;
    });
  };
  //获取用户菜单
  lableList(page) {
    this.setState({
      loading: true,
    });

    if (page) {
      this.setState({ searchData: page });
    }
    axios.post("/sys/permission/tree/all").then((res) => {
      if (res.data.code === 200) {
        // console.log(res.data)
        let arrdata = res.data.data;
        arrdata.map((item) => {
          item.child = item.children;
          delete item.children;
          return item;
        });
        // console.log("arrdata",arrdata)
        this.setState({
          lableListData: arrdata,
          total: arrdata.length,
          loading: false,
        });
      }
    });
  }
  showModal = (e) => {
    this.setState({
      modelTitle: "新增模块",
      visible: true,
      esshow: true,
      classShow: false,
      btnShow: false,
      labelorderNum: "",
    });
  };
  handleOk = (e) => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.state.modelTitle === "新增模块") {
          axios
            .post("sys/permission", {
              name: values.name,
              url: values.url,
              type: 1,
              pid: 0,
              orderNum: values.orderNum,
              perms: values.perms,
            })
            .then((res) => {
              if (res.data.code === 200) {
                message.success("添加成功");
                this.lableList();
                this.setState({
                  visible: false,
                });
              } else {
                message.error(res.data.msg);
              }
            });
        } else if (this.state.modelTitle === "添加菜单") {
          axios
            .post("sys/permission", {
              pidName: this.state.pidName,
              name: values.menuname,
              perms: values.perms,
              url: values.classurl,
              type: 2,
              pid: this.state.pid,
              orderNum: values.orderNum,
            })
            .then((res) => {
              if (res.data.code === 200) {
                message.success("添加菜单成功");
                this.lableList();
                this.setState({
                  visible: false,
                });
              } else {
                message.error(res.data.msg);
              }
            });
        } else if (this.state.modelTitle === "添加按钮") {
          axios
            .post("sys/permission", {
              pidName: this.state.pidName,
              name: values.btnname,
              perms: values.perms,
              url: values.url,
              type: 3,
              pid: this.state.pid,
              orderNum: values.orderNum,
            })
            .then((res) => {
              if (res.data.code === 200) {
                message.success("添加按钮成功");
                this.lableList();
                this.setState({
                  visible: false,
                });
              } else {
                message.error(res.data.msg);
              }
            });
        } else if (this.state.modelTitle === "编辑模块") {
          axios
            .put("sys/permission", {
              name: values.name,
              url: values.url,
              type: 1,
              orderNum: values.orderNum,
              id: this.state.labelId,
              pid: "0",
            })
            .then((res) => {
              if (res.data.code === 200) {
                message.success("编辑成功");
                this.lableList();
                this.setState({
                  visible: false,
                });
              } else {
                message.error(res.data.msg);
              }
            });
        } else if (this.state.modelTitle === "编辑菜单") {
          axios
            .put("sys/permission", {
              id: this.state.menuId,
              name: values.menuname,
              url: values.classurl,
              type: 2,
              orderNum: values.orderNum,
              perms: values.perms,
              pid: this.state.pid,
              pidName: this.state.pidName,
            })
            .then((res) => {
              if (res.data.code === 200) {
                message.success("编辑成功");
                this.lableList();
                this.setState({
                  visible: false,
                });
              } else {
                message.error(res.data.msg);
              }
            });
        } else if (this.state.modelTitle === "编辑按钮") {
          axios
            .put("sys/permission", {
              id: this.state.menuId,
              name: values.btnname,
              url: values.url,
              type: 3,
              orderNum: values.orderNum,
              perms: values.perms,
              pid: this.state.pid,
              pidName: this.state.pidName,
            })
            .then((res) => {
              if (res.data.code === 200) {
                message.success("编辑成功");
                this.lableList();
                this.setState({
                  visible: false,
                });
              } else {
                message.error(res.data.msg);
              }
            });
        }
      }
    });
  };
  delLable(id) {
    axios.delete(`sys/permission/${id}`).then((res) => {
      if (res.data.code === 200) {
        message.success("删除成功");
        this.lableList();
      } else {
        message.error(res.data.msg);
      }
    });
  }
  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };
  onExpand = (expanded, record) => {
    this.setState({
      pid: record.id,
      pidName: record.title,
    });
  };

  delmenuLable = (id) => {
    axios.delete(`sys/permission/${id}`).then((res) => {
      if (res.data.code === 200) {
        message.success("删除成功");
        this.lableList();
      } else {
        message.error(res.data.msg);
      }
    });
  };

  render() {
    const { lableListData, modelTitle, columns, visible, labelName, labelUrl, labelorderNum, labelperms, total, classShow, esshow, essName, essUrl, btnUrl, btnShow, loading } =
      this.state;
    const { getFieldDecorator } = this.props.form;
    const pagination = {
      showSizeChanger: true,
      total: total,
      pageSizeOptions: ["10", "20", "30", "40"],
      showTotal: () => `共 ${total} 条`,
      onShowSizeChange: (current, pageSize) => {
        let searchData = this.state.searchData;
        searchData.pageNum = current;
        searchData.pageSize = pageSize;
        this.lableList(searchData);
      },
      onChange: (current) => {
        let searchData = this.state.searchData;
        searchData.pageNum = current;
        this.lableList(searchData);
      },
    };
    return (
      <div className="menu-management">
        <span style={{ display: "flex", alignItems: "center", fontSize: "18px", fontWeight: "600" }}>菜单管理</span>
        <Divider />
        <div style={{ display: "flex", justifyContent: "end", marginBottom: "20px" }}>
          <Button
            className="my-button-primary"
            type="primary"
            onClick={(e) => {
              this.showModal(e);
            }}>
            新增模块
          </Button>
        </div>
        <Table
          loading={loading}
          dataSource={lableListData}
          columns={columns}
          rowKey={(record) => record.id}
          rowClassName={(record, index) => (index % 2 !== 0 ? "table-line" : "")}
          pagination={pagination}
          expandedRowRender={(record) => this.expandedRowRender(record)}
          onExpand={(expanded, record) => this.onExpand(expanded, record)}
        />
        <Modal
          getContainer={true}
          title={modelTitle}
          okText="确认"
          cancelText="取消"
          visible={visible}
          onOk={() => {
            this.handleOk();
          }}
          onCancel={() => {
            this.setState({ visible: false });
          }}
          destroyOnClose
          maskClosable={false}>
          <Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.handleOk}>
            {esshow && (
              <Form.Item label={"模块名称"}>
                {getFieldDecorator("name", {
                  rules: [
                    { required: true, message: "请输入模块名称!" },
                    { max: 50, message: "最多输入50个字符" },
                  ],
                  initialValue: modelTitle === "编辑模块" ? essName : "",
                })(<Input placeholder="请输入模块名称" />)}
              </Form.Item>
            )}
            {classShow && (
              <Form.Item label={"菜单名称"}>
                {getFieldDecorator("menuname", {
                  rules: [
                    { required: true, message: "请输入菜单名称!" },
                    { max: 50, message: "最多输入50个字符" },
                  ],
                  initialValue: modelTitle === "编辑菜单" ? labelName : "",
                })(<Input placeholder="请输入模块名称" />)}
              </Form.Item>
            )}
            {btnShow && (
              <Form.Item label={"按钮名称"}>
                {getFieldDecorator("btnname", {
                  rules: [
                    { required: true, message: "请输入按钮名称!" },
                    { max: 50, message: "最多输入50个字符" },
                  ],
                  initialValue: modelTitle === "编辑按钮" ? labelName : "",
                })(<Input placeholder="请输入按钮名称" />)}
              </Form.Item>
            )}
            {classShow && (
              <Form.Item label={"Class"}>
                {getFieldDecorator("perms", {
                  rules: [
                    { required: false, message: "请输入Class!" },
                    { max: 50, message: "最多输入50个字符" },
                  ],
                  initialValue: modelTitle === "编辑菜单" ? labelperms : "",
                })(<Input placeholder="请输入Class" />)}
              </Form.Item>
            )}
            {btnShow && (
              <Form.Item label={"Class"}>
                {getFieldDecorator("perms", {
                  rules: [
                    { required: true, message: "请输入Class!" },
                    { max: 50, message: "最多输入50个字符" },
                  ],
                  initialValue: modelTitle === "编辑按钮" ? labelperms : "",
                })(<Input placeholder="请输入Class" />)}
              </Form.Item>
            )}
            {esshow && (
              <Form.Item label={"URL"}>
                {getFieldDecorator("url", {
                  rules: [
                    { required: true, message: "请输入url!" },
                    { max: 50, message: "最多输入50个字符" },
                  ],
                  initialValue: modelTitle === "编辑模块" ? essUrl : "",
                })(<Input placeholder="请输入路径url" />)}
              </Form.Item>
            )}
            {btnShow && (
              <Form.Item label={"URL"}>
                {getFieldDecorator("url", {
                  rules: [
                    { required: true, message: "请输入url!" },
                    { max: 50, message: "最多输入50个字符" },
                  ],
                  initialValue: modelTitle === "编辑按钮" ? btnUrl : "",
                })(<Input placeholder="请输入路径url" />)}
              </Form.Item>
            )}
            {classShow && (
              <Form.Item label={"URL"}>
                {getFieldDecorator("classurl", {
                  rules: [
                    { required: true, message: "请输入URL!" },
                    { max: 50, message: "最多输入50个字符" },
                  ],
                  initialValue: modelTitle === "编辑菜单" ? labelUrl : "",
                })(<Input placeholder="请输入路径url" />)}
              </Form.Item>
            )}
            <Form.Item label={"排序"}>
              {getFieldDecorator("orderNum", {
                rules: [{ required: false, message: "orderNum" }],
                initialValue: modelTitle === "编辑模块" || "编辑菜单" || "新增模块" ? labelorderNum : "",
              })(<Input type="number" placeholder="请输入排序" />)}
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default Form.create()(menuManagement);
